import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PostCard } from './components/PostCard';
import { CommentList } from './components/CommentList';
import { CommentInput } from './components/CommentInput';
import { useStore } from '@/shared/state/store';
import { getPostById } from '@/shared/data';
import { NotFoundRedirect } from '@/shared/utils/NotFoundRedirect';

export function PostDetail() {
  const { id = '' } = useParams<{ id: string }>();
  const post = getPostById(id);
  const allComments = useStore((s) => s.comments);
  const localComments = useMemo(
    () => allComments.filter((c) => c.target === 'post' && c.postId === id),
    [allComments, id],
  );

  if (!post) return <NotFoundRedirect />;
  return (
    <div className="pb-24">
      <PostCard postId={id} />
      <h2 className="px-4 mt-2 mb-4 text-xs uppercase tracking-widest text-white/50">
        Comments
      </h2>
      <CommentList comments={localComments} />
      <CommentInput target="post" targetId={id} />
    </div>
  );
}
